/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";
import { OfferVO } from './offer-vo.model';

export class ShipmentGroupSolutionTrackingVoModel extends JSONable {

  order: any | undefined = undefined; // OrderDtoModel
  offer: OfferVO | undefined = undefined;

}
